<template>
  <div class="mainBody">
    <div class="mainCtn">
      <div class="topTitle">
        请选择角色
      </div>
      <div class="enterPanel">
        <div @click="$router.push('/fieldWorkCreateProject')" class="enter1">
          <div class="whiteLine"></div>
          <div class="e-title">我是任务创建人</div>
          <div class="e-bottom">
            <img src="../../assets/rsTool/任务入口.png" height="26" width="17" />
          </div>
        </div>
        <div @click="$router.push('/wyMobileDownload')" class="enter2" style="margin-left: 81px;">
          <div class="whiteLine"></div>
          <div class="e-title">我是外业核查人员</div>
          <div class="e-bottom">
            <img src="../../assets/rsTool/任务入口.png" height="26" width="17" />
          </div>
        </div>
        <div @click="$router.push('/auditor')" class="enter3" style="margin-left: 81px;">
          <div class="whiteLine"></div>
          <div class="e-title">我是审核人员</div>
          <div class="e-bottom">
            <img src="../../assets/rsTool/任务入口.png" height="26" width="17" />
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
export default {
  name:'fieldWorkEnter',
  data(){
    return{

    }
  },
  methods:{

  },
}

</script>
<style scoped lang="scss">
.mainBody{
  width: 100%;
  height:100%;
  background-image: url('../../assets/rsTool/选角色背景.png');
  background-size: 100% 100%;
  padding-top: 1px;
}
.mainCtn{
  width: 1600px;
  height:420px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 238px;
  .topTitle{
    width: 138px;
    height:48px;
    line-height: 48px;
    text-align: center;
    border-bottom: 3px solid #006699;
    margin-left: auto;
    margin-right: auto;
    font-size: 24px;
    font-weight: 600;
    color: #3A3A3A;
  }
  .enterPanel{
    display: flex;
    justify-content: flex-start;
    width: 100%;
    height:300px;
    margin-top: 80px;
    .enter1{
      width:480px;
      height:300px;
      border-radius: 16px;
      background-image: url("../../assets/rsTool/任务创建人背景.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding-left: 44px;
      padding-top: 40px;
      cursor: pointer;
    }
    .enter2{
      width:480px;
      height:300px;
      border-radius: 16px;
      background-image: url('../../assets/rsTool/外业核查人员背景.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding-left: 44px;
      padding-top: 40px;
      cursor: pointer;
    }
    .enter3{
      width:480px;
      height:300px;
      border-radius: 16px;
      background-image: url('../../assets/rsTool/外业审核人员背景.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding-left: 44px;
      padding-top: 40px;
      cursor: pointer;
    }
    .whiteLine{
      width: 76px;
      height: 6px;
      background: #FFFFFF;
      border-radius: 3px;
    }
    .e-title{
      width: 100%;
      height:30px;
      line-height: 30px;
      font-size: 26px;
      color: #FFFFFF;
      line-height: 37px;
      margin-top:25px;
    }
    .e-bottom{
      width: 100%;
      height:30px;
      margin-top: 130px;
    }
  }
}
</style>